module.exports = "/_next/static/images/logo-f9015ca0d47edcedabe7263d78fc3f92.svg";